interface VdzLogoProps {
  width?: number;
  color?: string;
  ariaLabel?: string;
}

/**
 * VDZ corporate logo. Path geometry copied verbatim from vdz-online.de
 * (svg id="logo-grey" in the page header).
 */
export function VdzLogo({
  width = 100,
  color = 'currentColor',
  ariaLabel = 'VDZ',
}: VdzLogoProps) {
  const height = (width * 48) / 100;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 48"
      role="img"
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={color} transform="translate(2,15)">
        <path d="M22.5474162,0.0315359356 L32.2123793,0.0315359356 L20.0034072,32.0597972 L10.1476434,32.0597972 L-2,0.0315359356 L7.66496309,0.0315359356 L14.0908575,17.648338 L14.9131175,23.3520636 L15.2969903,23.3520636 L16.1215219,17.648338 L22.5474162,0.0315359356 Z M66.7734242,32.060026 L57.9352641,32.060026 L57.9352641,28.7288489 C55.7728563,30.9709873 52.7200454,32.700637 48.0772288,32.700637 C41.0176036,32.700637 32.7518455,27.3195047 32.7518455,16.0470393 C32.7518455,4.772286 40.6996025,-0.611134155 48.5860307,-0.611134155 C52.5292447,-0.611134155 55.516184,0.734148911 57.9352641,2.65826976 L57.9352641,-14.7 L66.7734242,-14.7 L66.7734242,32.060026 Z M50.1124361,25.2695496 C54.3736513,25.2695496 57.9352641,22.3890881 57.9352641,17.5845057 L57.9352641,14.509573 C57.9352641,9.76905168 54.3736513,6.82224115 50.0488359,6.82224115 C45.3424191,6.82224115 41.7808064,10.0252961 41.7808064,16.0470393 C41.7808064,22.0687826 45.3424191,25.2695496 50.1124361,25.2695496 Z M98,0.031307146 L98,6.11711149 L82.608745,24.8206643 L98,24.8206643 L98,32.0595684 L72.3713799,32.0595684 L72.3713799,25.7175197 L87.7626349,7.27021126 L93.7910278,0.031307146 L98,0.031307146 Z M73.1341283,7.27135521 L73.1341283,0.0324510942 L80.3118683,0.0324510942 L80.3118683,7.27135521 L73.1341283,7.27135521 Z" />
      </g>
    </svg>
  );
}
